import type { PropsWithChildren, ReactNode } from 'react';

import { FileActionContainerStyled } from './styles/FileActionContainerStyled'
import { type UploadFile } from '../../types'
import { type UploadCommonProps } from '../../Upload'
import { Space } from '@ui/elements/Space'

export interface IFileActionContainerProps<UploadExtraProps = {}> {
  commonProps: UploadCommonProps<UploadExtraProps>
  innerProps: {
    file: UploadFile
    deleteButton: ReactNode
    cancelButton: ReactNode
  }
}

export const FileActionContainer = ({
  innerProps,
}: PropsWithChildren<IFileActionContainerProps>) => {
  return (
    <FileActionContainerStyled>
      <Space direction='horizontal'>
        {innerProps.cancelButton}
        {innerProps.deleteButton}
      </Space>
    </FileActionContainerStyled>
  )
}
